import { render, staticRenderFns } from "./crear.vue?vue&type=template&id=07b94302&"
import script from "./crear.vue?vue&type=script&lang=js&"
export * from "./crear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports